<template>
<div class="row justify-content-center">
    <div class="col-lg-5 col-md-7">
        <div class="card bg-secondary shadow border-0">
            <!--div class="card-header bg-transparent pb-5">
                        <div class="text-muted text-center mt-2 mb-3"><small>Connectez-vous avec</small></div>
                        <div class="btn-wrapper text-center">
                            <--a href="#" class="btn btn-neutral btn-icon">
                                <span class="btn-inner--icon"><img src="img/icons/common/github.svg"></span>
                                <span class="btn-inner--text">Github</span>
                            </a>
                            <a href="#" class="btn btn-neutral btn-icon">
                                <span class="btn-inner--icon"><img src="img/icons/common/google.svg"></span>
                                <span class="btn-inner--text">Google</span>
                            </a>
                        </div>
                    </div-->
            <div class="card-body px-lg-5 py-lg-5">
                <div class="text-center text-muted mb-4">
                    <small>{{ $t('message.errorTitle') }}</small>
                </div>
                <div class="row justify-content-center">

                    <div class="error text-center text-red">
                        <p>{{ $t('message.paiementError') }}</p>
                    </div>

                </div>
                <div class="row justify-content-center">

                    <b-btn variant="primary" :loading="loader" color="primary" @click="omsubmit">
                        {{ $t('message.back') }}
                    </b-btn>

                </div>
            </div>
        </div>

    </div>
</div>
</template>

<script>
import {
    mapGetters
} from "vuex";
import AppConfig from "../../constants/AppConfig";
export default {
    name: 'landing',

    data() {
        return {
            isLoading: true,
            opacity: 1,
            canCancel: false,
            fullPage: false,
        };
    },
    methods: {

        omsubmit: function () {
            window.location.href = 'http://medicasure.com';
        }
    },
    mounted() {
       // this.submit();
    }
}
</script>
<style scoped>

</style>
